import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Color, Size } from '../../constants/components';

export default class Button extends React.Component {
    constructor(props) {
        super(props);
        this.buttonClick = this.buttonClick.bind(this);
    }

    getStyles = () =>
        classNames(this.props.className, this.props.styles, {
            [`btn-${this.props.color}`]:
                this.props.color && !this.props.isSecondary && !this.props.isPrimary,
            'btn-lg': this.props.size === Size.LARGE,
            'btn-giant': this.props.size === Size.GIANT,
            primary: this.props.isPrimary,
            secondary: this.props.isSecondary && !this.props.isPrimary,
            disabled: !this.props.isEnabled,
        });

    buttonClick() {
        if (!this.props.isEnabled) {
            return;
        }
        this.props.onClick();
    }

    render() {
        return (
            <button
                aria-label={this.props.ariaLabel}
                className={this.getStyles()}
                onClick={this.buttonClick}
            >
                {this.props.text}
            </button>
        );
    }
}

Button.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.node,
    color: PropTypes.oneOf([
        Color.BLUE,
        Color.GREEN,
        Color.ORANGE,
        Color.GREY,
        Color.DARK_GREY,
        Color.RED,
    ]),
    size: PropTypes.oneOf([Size.NORMAL, Size.LARGE, Size.GIANT]),
    isEnabled: PropTypes.bool,
    styles: PropTypes.string,
    isPrimary: PropTypes.bool,
    isSecondary: PropTypes.bool,
    ariaLabel: PropTypes.string.isRequired,
};

Button.defaultProps = {
    className: 'btn',
    text: 'OK',
    color: Color.GREEN,
    size: Size.NORMAL,
    styles: '',
    isEnabled: true,
    isPrimary: false,
    isSecondary: false,
};
